// src/routes/appointmentRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AppointmentList from "./AppointmentList";
import AppointmentForm from "./AppointmentForm/AppointmentForm";
import AppointmentDetails from "./AppointmentDetails";
import AdminAppointmentDashboard from "./Admin/AdminAppointmentDashboard";
import AppointmentAnalytics from "./Admin/AppointmentAnalytics";
import ActiveVisitsView from "./Admin/ActiveVisitsView"; // Optional new component
import AppointmentCalendar from "./AppointmentCalendar";

// ========================================
// ADMIN APPOINTMENT ROUTES
// ========================================
export const AdminAppointmentRoutes = () => {
  return (
    <Routes>
      {/* Dashboard - Default landing page */}
      <Route index element={<AdminAppointmentDashboard />} />

      {/* ===== LIST VIEWS ===== */}

      {/* All appointments - main list */}
      <Route path="list" element={<AppointmentList view="all" />} />

      {/* Today's appointments */}
      <Route path="today" element={<AppointmentList view="today" />} />

      {/* Upcoming appointments (next 7 days) */}
      <Route path="upcoming" element={<AppointmentList view="upcoming" />} />

      {/* Pending approvals - filtered all view */}
      <Route path="pending" element={<AppointmentList view="pending" />} />

      {/* Search results */}
      <Route path="search" element={<AppointmentList view="search" />} />

      {/* ===== OPTIONAL: VISIT TRACKING VIEWS ===== */}

      {/* 🆕 Active visits - currently checked in or in progress */}
      <Route path="active-visits" element={<ActiveVisitsView />} />
      {/* Alternative: Use existing AppointmentList with filter */}
      {/* <Route path="active-visits" element={<AppointmentList view="active" />} /> */}

      {/* ===== ACTIONS ===== */}

      {/* Book new appointment (Admin books FOR customer) */}
      <Route path="book" element={<AppointmentForm mode="add" />} />

      <Route path="calendar" element={<AppointmentCalendar />} />

      {/* ===== SINGLE APPOINTMENT ===== */}

      {/* View appointment details - VISIT TRACKING IS HERE */}
      <Route path=":id" element={<AppointmentDetails />} />
      {/* 
        Within AppointmentDetails:
        - VisitTracking component shows based on status
        - All modals (CheckIn, ActivityTracker, Complete) handled here
        - No need for separate routes
      */}

      {/* Reschedule appointment */}
      <Route
        path=":id/reschedule"
        element={<AppointmentForm mode="reschedule" />}
      />

      {/* ===== ANALYTICS & REPORTS ===== */}

      {/* Analytics dashboard */}
      <Route path="analytics" element={<AppointmentAnalytics />} />

      {/* ===== FALLBACK ===== */}

      {/* Catch-all redirect to dashboard */}
      <Route path="*" element={<Navigate to="/appointments" replace />} />
    </Routes>
  );
};

export default AdminAppointmentRoutes;
